import {CONFIG} from '../config.js';
import './pcsp.js';

class AnchorJump {
	#hash
	constructor(){
		this.#hash = location.hash

		if ($(this.#hash)[0]) {
			$(window).scrollTop($(this.#hash).offset().top - CONFIG.scrollOffset[pcsp.mode]);
		}
	}
}

/**
ハッシュ付きでページ遷移してきたときにスクロール位置を調整する<br/>importするだけで使える
@name anchorJump
@example <caption>JS</caption>
import '/assets/js/modules/anchorJump.js';
*/
$(window).on('load', function() {
	const anchorJump = new AnchorJump();
});
